module.exports = __webpack_public_path__ + "img/logo_white.f4da9237.png";